import React, { useCallback } from 'react'
import ChildrenTable from './ChildrenTable'

export default function ChildrenPanel({
  handleRemoveSelected,
  handleRestoreSelected,
  currentPerson,
  onRemove,
  onRestore,
  accessControls,
  tombstonedChildrenRelationships,
  showTombstonedRelationships,
}) {
  const currentPersonChildren = currentPerson.relationships.children ? currentPerson.relationships.children : []

  const removeSelected = useCallback(
    (selected) => {
      handleRemoveSelected(selected, 'parentchild')
    },
    [handleRemoveSelected]
  )
  const restoreSelected = useCallback(
    (selected) => {
      handleRestoreSelected(selected, 'parentchild')
    },
    [handleRestoreSelected]
  )

  const tombstonedChildrenRelationshipsNewParents = tombstonedChildrenRelationships.filter((relationship) => {
    if (currentPersonChildren.length > 0) {
      return currentPersonChildren.some(
        (c) =>
          relationship.parent1.personId !== c.parent.personId && relationship.parent2.personId !== c.parent.personId
      )
    }
    return true
  })

  const tombstonedChildren = []
  tombstonedChildrenRelationshipsNewParents.forEach((newParents) => {
    const parent = newParents.parent1.personId === currentPerson.id ? newParents.parent2 : newParents.parent1
    const indexOfParent = tombstonedChildren.findIndex((tc) => tc.parent.personId === parent.personId)
    const childObject = {
      child: newParents.child,
      relationshipId: newParents.relationshipId,
    }
    if (indexOfParent === -1) {
      const childrenObject = {
        children: [],
        parent,
      }
      childrenObject.children.push(childObject)
      tombstonedChildren.push(childrenObject)
    } else {
      tombstonedChildren[indexOfParent].children.push(childObject)
    }
  })

  // Get all spouses without children
  const couplesWithZeroChildren = (currentPerson.relationships.spouses || [])
    .filter(
      (spouseRelationship) =>
        !currentPersonChildren.some(
          (parentWithChildren) => parentWithChildren.parent.personId === spouseRelationship.spouse.personId
        ) &&
        // Also filter out spouses that have tombstoned children
        !tombstonedChildren.some(
          (tombstonedChild) => tombstonedChild.parent.personId === spouseRelationship.spouse.personId
        )
    )
    .map((spouseRelationship) => ({
      parent: spouseRelationship.spouse,
      children: [],
      relationshipPersonIds: [spouseRelationship.relationshipId],
    }))

  if (currentPersonChildren.length === 0 && tombstonedChildren.length === 0 && couplesWithZeroChildren.length === 0) {
    return (
      <ChildrenTable
        currentPerson={currentPerson}
        accessControls={accessControls}
        onRemoveSelected={() => {}}
        onRemove={() => {}}
        family={{ children: [] }}
      />
    )
  }
  const filterTombstonedChildrenSharedParents = (parentWithChildren) => {
    if (!parentWithChildren || !parentWithChildren.parent) {
      return []
    }
    return tombstonedChildrenRelationships.filter(
      (relationship) =>
        relationship.parent1.personId === parentWithChildren.parent.personId ||
        relationship.parent2.personId === parentWithChildren.parent.personId
    )
  }

  const tombstonedRelationshipIds = currentPersonChildren.flatMap((parentWithChildren) =>
    filterTombstonedChildrenSharedParents(parentWithChildren).map((r) => r.relationshipId)
  )

  const allTombstonedChildren = tombstonedChildren.filter((tombstonedChild) =>
    tombstonedChild.children.some((child) => !tombstonedRelationshipIds.includes(child.relationshipId))
  )

  return (
    <>
      {[...currentPersonChildren, ...allTombstonedChildren, ...couplesWithZeroChildren].map((parentWithChildren) => {
        const tombstonedChildrenRelationshipsSharedParents = filterTombstonedChildrenSharedParents(parentWithChildren)
        if (tombstonedChildren.includes(parentWithChildren)) {
          // remove tombstoned children from non-tombstoned section
          parentWithChildren.children = []
        }
        return (
          <ChildrenTable
            key={parentWithChildren?.relationshipPersonIds?.[0] || parentWithChildren?.parent?.personId}
            currentPerson={currentPerson}
            family={parentWithChildren}
            onRemove={onRemove}
            onRestore={onRestore}
            onRemoveSelected={removeSelected}
            onRestoreSelected={restoreSelected}
            accessControls={accessControls}
            tombstonedChildrenRelationships={tombstonedChildrenRelationshipsSharedParents}
            showTombstonedRelationships={showTombstonedRelationships}
          />
        )
      })}
    </>
  )
}
